import { Component, ViewEncapsulation} from '@angular/core';

export const ROOT_SELECTOR = 'fint-app';

@Component({
    selector: ROOT_SELECTOR,
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './app.component.scss',
        '../../node_modules/font-awesome/css/font-awesome.min.css'
      ],
})
export class AppComponent { }